"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Block = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const version_1 = require("../version");
class Block {
    constructor(config) {
        this.config = config;
    }
    async getRequest(endpoint, blockNumber) {
        const baseUrl = this.config.getConstants().Urls.ApiBaseUrl;
        const uri = `${baseUrl}${endpoint}`;
        try {
            const result = await axios_1.default.get(uri, {
                params: {
                    blockNumber,
                    mock: this.config.mock,
                    chainId: this.config.chainId.toString(),
                },
                headers: {
                    "x-axiom-api-key": this.config.apiKey,
                    "x-provider-uri": this.config.providerUri,
                    "User-Agent": 'axiom-sdk-ts/' + version_1.SDK_VERSION,
                }
            });
            return result.data;
        }
        catch (error) {
            console.error(error);
            return null;
        }
    }
    async getBlockHashWitness(blockNumber) {
        const endpoint = this.config.getConstants().Endpoints.GetBlockHashWitness;
        const data = await this.getRequest(endpoint, blockNumber);
        return data?.blockHashWitness ?? null;
    }
    async getBlockMerkleProof(blockNumber) {
        const endpoint = this.config.getConstants().Endpoints.GetBlockMerkleProof;
        const data = await this.getRequest(endpoint, blockNumber);
        return data?.merkleProof ?? null;
    }
    async getBlockRlpHeader(blockNumber) {
        const endpoint = this.config.getConstants().Endpoints.GetBlockRlpHeader;
        const data = await this.getRequest(endpoint, blockNumber);
        return data ?? null;
    }
    async getBlockParams(blockNumber) {
        const endpoint = this.config.getConstants().Endpoints.GetBlockParams;
        const data = await this.getRequest(endpoint, blockNumber);
        return data ?? null;
    }
    async getBlockMmrProof(blockNumber) {
        const endpoint = this.config.getConstants().Endpoints.GetBlockMmrProof;
        const data = await this.getRequest(endpoint, blockNumber);
        return data ?? null;
    }
}
exports.Block = Block;
//# sourceMappingURL=block.js.map